var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_small",
    transform: "translate(-429 -5123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5955",
    "data-name": "Rectangle 5955",
    width: 64,
    height: 64,
    rx: 12,
    transform: "translate(429 5123)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M4.98,31.91H2.857A2.868,2.868,0,0,1,0,29.053v-9.41a.829.829,0,0,1,.107-.409L6.649,7.777a.819.819,0,0,1,.714-.411h8.189V2.858A2.869,2.869,0,0,1,18.409,0H36l-.808,1.636h-.009L24.546,22.912h.007l-.409.82h-.007l-.409.818-2.864,5.728h0l-.409.818h0l-.409.814H14.658a4.908,4.908,0,0,1-9.678,0Zm.748-.812a4.091,4.091,0,0,0,4.091,4.09h0A4.09,4.09,0,1,0,5.727,31.1Zm8.925-.819h.893V9h-7.7l-.466.818h5.713a.817.817,0,0,1,.816.816v9.005a.814.814,0,0,1-.816.823H1.636v.82h1.63a2.455,2.455,0,1,1,0,4.908H1.629v2.858a1.229,1.229,0,0,0,1.228,1.228H4.974a4.908,4.908,0,0,1,9.678,0ZM2.229,18.821H12.273V11.457H6.436Z",
    transform: "translate(443 5137)",
    fill: "#0078d7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Logo",
    transform: "translate(439 5140)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Tajawal-Bold, Tajawal",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 21
  }, "Logo")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.88d76088671dd1080558160697062697.svg";
export { ForwardRef as ReactComponent };